module.exports = __webpack_public_path__ + "fonts/nationale-bold.84fba92.woff2";